export const selectReminders = (state) => state.nestedReminders.items;
export const selectIsLoading = (state) => state.nestedReminders.fetching;
export const selectMeta = (state) => state.nestedReminders.meta;
export const selectParams = (state) => state.nestedReminders.params;
